import { render } from "./DeviceSpecs.vue?vue&type=template&id=08401f0c&scoped=true&ts=true&lang=pug"
import script from "./DeviceSpecs.vue?vue&type=script&lang=ts"
export * from "./DeviceSpecs.vue?vue&type=script&lang=ts"

import "./DeviceSpecs.vue?vue&type=style&index=0&id=08401f0c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08401f0c"]])

export default __exports__